/* @ngInject */
const myButton = (
  optionsHandler
) => {
  const defaultOptions = {
    label: () => null,
    icon: () => null,
    style: () => null,
  }

  return {
    restrict: 'E',
    scope: {
      myOptions: '=',
      myLabel: '=',
      myStyle: '=?',
      myIcon: '=?',
      myType: '=?',
      myClick: '&?',
      myDisabled: '=?',
      leftIcon: '=?',
    },
    template: require('./myButton.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.defaultClass = 'btn waves-effect waves-light'
    },
    link: {
      pre: (scope, element, attrs) => {

        scope.options = optionsHandler.setDefaults(scope.myOptions, defaultOptions)
      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myButton



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/buttons/myButton.js